import { atom } from 'jotai';

export const linkedAccountModalStepAtom = atom<number>(1);

export const linkedAccountMultiStepAtom = atom<number>(1);
